<template lang="pug">
    div.car-selector
        div.showroom-label <span>Volkswagen</span>Digital Showroom
        div.slider(:style="sliderStyle")
            div.cars-image(:style="imageStyle")
            div.slider-actions
                .button.prev
                div.dots
                    .dot
                    .dot
                    .dot.active
                    .dot
                .button.next
</template>
<script>
export default {
  name: 'CarSelector',
  data() {
    return {
      sliderHeight: 0,
      imageSize: {
        carsAreaHeight: 990,
        width: 2880,
        height: 1664
      }
    }
  },

  mounted() {
    window.addEventListener('resize', this.onWindowResize)
    this.updateSliderHeight()
  },

  destroyed() {
    window.removeEventListener('resize', this.onWindowResize)
  },

  computed: {
    sliderStyle() {
      return {
        height: this.sliderHeight.toFixed(2) + 'px'
      }
    },

    imageStyle() {
      let toHeight = this.sliderHeight
      let ratio = toHeight / this.imageSize.height
      let toWidth = this.imageSize.width * ratio

      const top = -(toHeight - this.sliderHeight)

      return {
        top: top,
        width: toWidth + 'px',
        height: toHeight + 'px',
      }
    }
  },

  methods: {
    onWindowResize() {
      this.updateSliderHeight()
    },

    updateSliderHeight() {
      const siteHeaderEl = document.querySelector('#site-header')
      const showRoomLabelEl = document.querySelector('.car-selector .showroom-label')

      this.sliderHeight = window.innerHeight - (siteHeaderEl.getBoundingClientRect().height + showRoomLabelEl.getBoundingClientRect().height);
    }
  }
}
</script>